var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    fill: "currentColor",
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7 7.058c-.628 0-.953-.329-.953-.961V1.676c0-.63.325-.961.952-.961h3.12c.627 0 .952.33.952.96v1.937h.771l.437.024-.188-.156-.448-.418a.26.26 0 0 1-.08-.185.23.23 0 0 1 .235-.237c.07 0 .123.026.173.076l.929.964a.28.28 0 0 1 .09.205c0 .07-.023.135-.09.205l-.93.964a.242.242 0 0 1-.172.076c-.138 0-.234-.109-.234-.243 0-.068.029-.135.079-.182l.448-.419.185-.152-.434.02h-.77v-.542H3.6a.273.273 0 0 0-.267.273c0 .15.123.27.267.27h2.17v1.942c0 .632-.325.96-.952.96H1.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.50404eaf68c4edf31ec7f57e1d436be0.svg";
export { ForwardRef as ReactComponent };